import ProductPageLayout from "@/components/ProductPageLayout";
import lamelliverho from "@/assets/lamelliverho.png?format=webp&w=800";

const VerticalBlindInstallation = () => (
  <ProductPageLayout title="Vertical blind installation" metaDescription="Vertical blind installation in Central Uusimaa. Vertical blinds for large windows and sliding doors." image={lamelliverho} partner="osio" path="/en/vertical-blind-installation" alternatePath="/lamelliverho-asennus">
    <p className="text-muted-foreground leading-relaxed">
      Vertical blinds are an excellent choice for large windows, sliding doors and office spaces. 
      The adjustable slat angle lets you control the amount of light seamlessly.
    </p>
    <h2 className="font-display text-2xl font-bold mt-8 mb-3">Use cases for vertical blinds</h2>
    <ul className="space-y-2 text-muted-foreground">
      <li>✓ Large panoramic windows</li>
      <li>✓ Sliding doors and balcony windows</li>
      <li>✓ Office spaces and meeting rooms</li>
      <li>✓ Room dividers and furniture solutions</li>
    </ul>
    <p className="text-muted-foreground mt-6 leading-relaxed">
      We serve Hyvinkää, Järvenpää, Kerava, Mäntsälä, Nurmijärvi, Pornainen and Tuusula. 
      Browse <a href="https://osio.fi" target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 text-foreground">Osio vertical blinds</a>.
    </p>
  </ProductPageLayout>
);

export default VerticalBlindInstallation;
